import {
  STOCK_MASSIVE_UPLOAD_GO_BACK_STEP,
  STOCK_MASSIVE_UPLOAD_GO_BACK_TRANSLATOR_STEP,
} from './constants'

const getTranslatorStepKey = (translator, previousTranslatorStep) => {
  let previousTranslatorStepKey;
  for(let key in translator) {
    const currentTranslator = translator[key]
    if(currentTranslator?.order === previousTranslatorStep
      && currentTranslator.inconsistencies?.length > 0){
      previousTranslatorStepKey = key
    }
  }
  return previousTranslatorStepKey
}

export function goBackStep() {
  return (dispatch, getState) => {
    const {
      stock: { currentStep, translatorStepKey, translator}
    } = getState()
    if (currentStep.order === 1 && translator[translatorStepKey]?.order > 0) {

      
      // si no encuentro una key, vuelvo a buscarla reduciendo en uno el paso
      let previousTranslatorStepKey;
      let previousTranslatorStep = translator[translatorStepKey]?.order - 1

      while(previousTranslatorStepKey === undefined && previousTranslatorStep >= 0) {
        previousTranslatorStepKey = getTranslatorStepKey(translator, previousTranslatorStep)
        if(!previousTranslatorStepKey) previousTranslatorStep = previousTranslatorStep - 1
      }
      
      if(previousTranslatorStep < 0){
          dispatch({
            type: STOCK_MASSIVE_UPLOAD_GO_BACK_STEP,
          })
      } else {
        dispatch({
          type: STOCK_MASSIVE_UPLOAD_GO_BACK_TRANSLATOR_STEP,
          data: { 
            previousTranslatorStep,
            previousTranslatorStepKey,
            
          }
        })
      }
    } else {
      dispatch({
        type: STOCK_MASSIVE_UPLOAD_GO_BACK_STEP,
      })
    }
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case STOCK_MASSIVE_UPLOAD_GO_BACK_STEP:
      const previousStepOrder = state.currentStep.order - 1
      const previousStep = state.steps.find(step => step.order === previousStepOrder)
      return {
        ...state,
        currentStep: previousStep
      }
    case STOCK_MASSIVE_UPLOAD_GO_BACK_TRANSLATOR_STEP:
      return {
        ...state,
        ...action.data,
        saveValidateDataPending: false,
        saveValidateDataError: null,
        translatorStep: action.data.previousTranslatorStep,
        translatorStepKey: action.data.previousTranslatorStepKey,
      }
    default:
      return state
  }
}
